import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import { searchUrl } from '@/constants/urls';
import actions from '../constants';

export function* closeTab({ items }) {
  const itemsUrls = items.map((item) => searchUrl(item));

  yield call(listener.closeTab, itemsUrls);
}

export default function* searchLayout() {
  yield takeEvery(actions.DESTROY_SEARCH, closeTab);
}
